import {
    Settings as SettingsIcon,
    Users as UsersIcon,
    FileCode2 as FileCode2Icon,
    Home as HomeIcon,
} from 'lucide-react';

import { ROUTES } from '@/constants/routes';
import Home from '@/views/Home/Home';
import WebRTC from '@/WebRTC';
import NumberManagement from '@/views/NumberManagement/NumberManagement';
import UserManagement from '@/views/UserManagement/UserManagement';

import TestMock from '@/test-mock';

export const appRoutes = [
    {
        hidden: true,
        title: 'Home',
        path: ROUTES.HOME,
        element: <Home />,
        icon: HomeIcon,
    },
    {
        hidden: true,
        title: 'Web RTC',
        path: ROUTES.WEBRTC,
        element: <WebRTC />,
        icon: FileCode2Icon,
    },
    {
        title: 'Number Management',
        path: ROUTES.NUMBER_MANAGEMENT,
        element: <NumberManagement />,
        icon: SettingsIcon,
    },
    {
        title: 'User Management',
        path: ROUTES.USER_MANAGEMENT,
        element: <UserManagement />,
        icon: UsersIcon,
        roles: ['admin'],
    },
    {
        hidden: true,
        title: 'Test Mock',
        path: ROUTES.TEST_MOCK,
        element: <TestMock />,
        icon: FileCode2Icon,
    },
];
